  /* services */
  import SelosService from "@/services/Registros/SelosService"
  import Selo  from "@/entities/Selo/Selo"
  import { useCasePapelSegurancaLoteItem } from "@/entities/PapelSegurancaLoteItem/useCasePapelSegurancaLoteItem.js"

  // Store
  import store from '@/store/index'

  // Util
  import {  matriculaTransforma, iniciaisSolicitante } from '@/utils/conversors'


export class UseCaseSelo {
  constructor (selo) {
    this.selo = selo || null
  }

  async

  async create (ordemServico, itemOs) {
    const selosCriados = []
    const papeisConsumidos = []
    const selosDuplosCriados = []

    try {
      for (let index = 0; index < itemOs.quantidade; index++) {
        const payload = this.__handlerPayload(ordemServico, itemOs, index)
  
        const newSelo = await SelosService.storeSelo(payload)
        selosCriados.push(new Selo(newSelo))
  
        if (ordemServico.uf_cartorio === 'SP' && ordemServico.num_selo) {
          await this.vincular(newSelo.num_selo, ordemServico.num_selo)
        }
  
        if (ordemServico.uf_cartorio === 'OUTRO') {
          const seloOutroEstado = await this.__vincularOutrosEstados(payload)
          await this.vincular(newSelo.num_selo, seloOutroEstado.num_selo)
        }
  
        if (itemOs.custa && itemOs.custa.selo_duplo) {
          payload.ato = itemOs.custa.selo_duplo
          const seloDuplo = await await SelosService.storeSelo(payload)
          selosDuplosCriados.push(new Selo(seloDuplo))
          await this.vincular(newSelo.num_selo, seloDuplo.num_selo)
        }
        if (itemOs.impressosSeguranca) {
          const papelConsumido = await new useCasePapelSegurancaLoteItem(itemOs.papeisSelecionados[index]).consumir(itemOs)
          papeisConsumidos.push(papelConsumido.item)
        }
      }
  
      return {selos: [...selosCriados, ...selosDuplosCriados], papeisConsumidos: papeisConsumidos}
    } catch (error) {
      const message = error.message
      // Separa os itens criados para serem tratados no erro do componente pai
      const data = {selos: [...selosCriados, ...selosDuplosCriados], papeisConsumidos: papeisConsumidos}
      throw ({ message, data })
    }
  }

  async excluir () {
    if (!this.selo.selo_id) {
      throw Error('O ID do Selo a ser excluido não foi informados')
    }
    const seloCancelado = await SelosService.excluirSelo(this.selo.selo_id)
    return seloCancelado
  }

  async cancelar () {
    if (!this.selo?.selo_id) {
      throw ('Erro ao cancelar selo')
    }
    // if (this.selo.cancelarSelo && !this.selo.num_ordem_judicial) {
    //     throw ('Para cancelar um selo é preciso informar o número da ordem Judicial')
    // }
    const seloCancelado = await SelosService.cancelarSelo(this.selo.selo_id, this.selo.num_ordem_judicial)
    return seloCancelado
  }
  // Deleta selo no banco de dados
  async delete (id) {
    if (!id && !this.selo.selo_id) {
      throw Error('O ID do Selo a ser excluido não foi informados')
    }
    const seloExcluido = await SelosService.delete(id || this.selo.selo_id)
    return seloExcluido
  }

  async retificar (seloId) {
    if (!this.selo.selo_id) {
      throw ('O ID do Selo a ser retificado não foi informado')
    }
    const seloRefitifcado =  await SelosService.retificarSelo(seloId || this.selo.selo_id)
    return seloRefitifcado
  }

  async vincular (numSeloVinculador, numSeloVinculado) {
    if (!numSeloVinculador) {
      throw ('O numero do selo vinculador não foi informado')
    }
    if (!numSeloVinculado) {
      throw ('O numero do selo a ser vinculado não foi informado')
    }
    const payload = {
        numSeloVinculador,
        vinculacoes: Array.isArray(numSeloVinculado) ? numSeloVinculado : [numSeloVinculado],
        realizarEnvioVinculacaoTJ: true
    }   

    const { vinculacoes } = await SelosService.vincularSelos(payload)

    return vinculacoes
  }

  async __vincularOutrosEstados (payload) {
    payload.ato = 'XX'
    const segundoSelo = await SelosService.gerarSeloVinculado(payload)
    return segundoSelo
  }

  __handlerPayload (ordemServico, itemOs, index) {
    const payload = {
      ordem_servico_item_id: itemOs.ordem_servico_item_id,
      cpf: process.env.NODE_ENV === 'production' ? ordemServico.cpf_solicitante : '40300169876', // hmlg > CPF VENDRA "40300169876"
      natureza: itemOs.custa.tipo === 'ATOS_NOTARIAIS' ? 1 : 2,
      ato: itemOs.custa.tipo_ato,
      cns: process.env.NODE_ENV === 'production' ? store.state.auth.cartorioObj.cns : '115204', //  hmlg > CNS VENDRA 115204
      iniciais_solicitante: iniciaisSolicitante(ordemServico.nome_solicitante),
      valor_vinculado: ordemServico.valor_da_custa,
      cpf_solicitante: ordemServico.cpf_solicitante,
      num_matricula: ordemServico.num_matricula_registro ? matriculaTransforma(ordemServico.num_matricula_registro) : null,
      cartorio: store.state.auth.cartorioObj,
      numero_serie: itemOs.impressosSeguranca && itemOs.papeisSelecionados.length ? itemOs.papeisSelecionados[index].numero_serie : null,
      codigo_serventia: itemOs.impressosSeguranca && itemOs.papeisSelecionados.length ? itemOs.papeisSelecionados[index].papelSegurancaLote.codigo_serventia : null,
      tipo_selo: itemOs.custa.tipo_selo,
      registro_id: ordemServico.registro_id
    }
    return payload
  }

}